<template>
    <OnBoardingCard displayImage="/images/resized/Carbn_Image 46.webp">
        <div class="h1 reg">Welcome to Zilch!</div>
        <div class="block-text">
            You're all set to go! What's next?
            <br />
            <ol>
                <li>
                    <div class="b1 reg"><span class="semi">Explore hubs</span> - find out where you can book a car from.</div>
                </li>
                <li>
                    <div class="b1 reg"><span class="semi">Book your first ride</span> - Choose from a variety of cars ready for you.</div>
                </li>
            </ol>
        </div>
        <div class="buttons">
            <SelectableButton @click="goToHome">
                <div class="btn-anchor bu1-semi">Get started</div>
            </SelectableButton>
        </div>
    </OnBoardingCard>
</template>
<script>
import OnBoardingCard from '@/components/OnBoardingCard.vue';
import { mapState, mapMutations, mapActions } from 'vuex';
export default {
    components: {
        OnBoardingCard,
    },
    computed: {
        ...mapState(['isMobile']),
    },
    methods: {
        goToHome() {
            this.loadProfile({ router: this.$router, bus: this.$bus }).then(() => {
                this.setFromOnboarding(true);
                this.setLoggedIn(true);
                this.$router.push('/home');
            }).catch(() => {
                console.error('Could not load the profile');
                this.$router.push({ name: 'Home' });
            });
        },
        handleBackButton() {
            this.$router.back();
        },
        ...mapMutations(['setLoggedIn','setFromOnboarding']),
        ...mapActions(['loadProfile']),
    }
}
</script>
<style scoped>
div.block-text, ol {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
}
</style>